(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* =========================================================
     Cart drawer — rendered by Shopify (sections/cart-drawer)
     ========================================================= */
  const drawer = () => $('#CartDrawer');
  let lastFocus = null;

  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = Number(n) === 0;
    });
  }

  function openCart() {
    const d = drawer();
    if (!d) { window.location.href = ROOT + 'cart'; return; }
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('.cd__panel', d)?.focus(), 50);
  }
  function closeCart() {
    const d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  async function refreshCart() {
    const d = drawer();
    try {
      const res = await fetch(`${ROOT}?section_id=cart-drawer`, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cd-inner]', doc);
      const cur = d && $('[data-cd-inner]', d);
      if (fresh && cur) cur.replaceWith(fresh);
      if (fresh) setCount(fresh.dataset.count || 0);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {
      const cart = await fetch(`${ROOT}cart.js`).then((r) => r.json());
      setCount(cart.item_count);
    }
  }

  async function changeLine(key, quantity) {
    const inner = $('[data-cd-inner]');
    inner?.classList.add('is-busy');
    try {
      await fetch(`${ROOT}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
    } finally {
      await refreshCart();
    }
  }

  async function quickAdd(btn) {
    const id = btn.dataset.addToCart;
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';
    try {
      const res = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      const body = await res.json();
      if (!res.ok) {
        btn.textContent = body.description || 'Sold out';
        setTimeout(() => { btn.innerHTML = label; btn.disabled = false; btn.classList.remove('is-loading'); }, 2200);
        return;
      }
      await refreshCart();
      openCart();
      btn.innerHTML = label;
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1600);
    } catch (e) {
      btn.innerHTML = label;
    }
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-cart]');
    if (opener) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-close-cart]')) { e.preventDefault(); closeCart(); return; }
    const add = e.target.closest('[data-add-to-cart]');
    if (add) { e.preventDefault(); quickAdd(add); return; }
    const q = e.target.closest('[data-cd-qty]');
    if (q) { e.preventDefault(); changeLine(q.dataset.key, Math.max(0, Number(q.dataset.cdQty))); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  window.HaloCart = { refresh: refreshCart, open: openCart, close: closeCart };

  /* =========================================================
     Predictive search (header)
     ========================================================= */
  function bindSearch(form) {
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';
    const input = $('input[type="search"]', form);
    const box = $('[data-ps-results]', form);
    if (!input || !box) return;
    const money = form.dataset.money || '';
    const fmt = (price) => {
      if (!money) return price;
      const n = Number(price);
      const parts = n.toFixed(2).split('.');
      const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => (k === 'amount_no_decimals' ? whole : `${whole}.${parts[1]}`));
    };
    const esc = (t) => { const d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; };
    let t; let ctrl;
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      t = setTimeout(async () => {
        try {
          ctrl?.abort(); ctrl = new AbortController();
          const url = `${ROOT}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
          const data = await fetch(url, { signal: ctrl.signal }).then((r) => r.json());
          const res = data.resources?.results || {};
          const products = res.products || [];
          const cols = res.collections || [];
          let html = '';
          if (cols.length) {
            html += '<div class="ps__group"><p class="ps__label">Collections</p>' + cols.slice(0, 3).map((c) => `<a class="ps__col" href="${c.url}">${esc(c.title)}</a>`).join('') + '</div>';
          }
          if (products.length) {
            html += '<div class="ps__group"><p class="ps__label">Products</p>' + products.map((p) => {
              const img = p.featured_image?.url ? `${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=120` : '';
              const sale = Number(p.compare_at_price_max) > Number(p.price);
              return `<a class="ps__item" href="${p.url}">${img ? `<img src="${img}" alt="" width="48" height="48" loading="lazy">` : '<span class="ps__ph"></span>'}<span class="ps__t">${esc(p.title)}</span><span class="ps__p${sale ? ' is-sale' : ''}">${fmt(p.price)}</span></a>`;
            }).join('') + '</div>';
          }
          if (!html) html = `<p class="ps__none">No results for “${esc(q)}”</p>`;
          html += `<button type="submit" class="ps__all">See all results for “${esc(q)}”</button>`;
          box.innerHTML = html;
          box.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        } catch (err) { /* aborted */ }
      }, 220);
    });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  }
  $$('[data-predictive-search]').forEach(bindSearch);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-toggle-search]')) {
      e.preventDefault();
      const bar = $('#SearchBar');
      bar?.classList.toggle('is-open');
      if (bar?.classList.contains('is-open')) $('input[type="search"]', bar)?.focus();
    }
  });

  /* =========================================================
     Mobile menu
     ========================================================= */
  const menu = $('[data-mnav]');
  if (menu) {
    const openMenu = () => { menu.classList.add('is-open'); menu.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; $('.mnav__panel', menu)?.focus(); };
    const closeMenu = () => { menu.classList.remove('is-open'); menu.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-menu]')) { e.preventDefault(); openMenu(); return; }
      if (e.target.closest('[data-close-menu]')) { e.preventDefault(); closeMenu(); return; }
      const tg = e.target.closest('[data-mnav-toggle]');
      if (tg) {
        const g = tg.closest('.mnav__group');
        const open = g.classList.toggle('is-open');
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });
  }

  /* =========================================================
     Legacy sections still used by some templates
     ========================================================= */
  function bindSplit(root) {
    if (!root || root.dataset.bound === '1') return;
    const items = $$('[data-split-item]', root);
    if (items.length <= 2) return;
    root.dataset.bound = '1';
    const page = 2;
    const pages = Math.ceil(items.length / page);
    let i = 0;
    const show = (n) => {
      i = ((n % pages) + pages) % pages;
      items.forEach((el, x) => el.classList.toggle('is-hidden', !(x >= i * page && x < i * page + page)));
    };
    $('[data-split-prev]', root)?.addEventListener('click', () => show(i - 1));
    $('[data-split-next]', root)?.addEventListener('click', () => show(i + 1));
    show(0);
  }

  function bindCore(root) {
    if (!root || root.dataset.bound === '1') return;
    const track = $('[data-core-track]', root);
    const items = $$('[data-core-item]', root);
    if (!track || items.length <= 4) return;
    root.dataset.bound = '1';
    let i = 0;
    const sizeOf = () => (window.innerWidth < 990 ? 2 : 4);
    const gap = 24;
    const layout = () => {
      const vw = track.parentElement.clientWidth;
      const size = sizeOf();
      const w = (vw - gap * (size - 1)) / size;
      items.forEach((el) => { el.style.flex = `0 0 ${w}px`; el.style.width = `${w}px`; });
    };
    const go = (n) => {
      const pages = Math.max(1, Math.ceil(items.length / sizeOf()));
      i = ((n % pages) + pages) % pages;
      const vw = track.parentElement.clientWidth;
      track.style.transform = `translate3d(-${i * (vw + gap)}px,0,0)`;
    };
    layout();
    $('[data-core-prev]', root)?.addEventListener('click', () => go(i - 1));
    $('[data-core-next]', root)?.addEventListener('click', () => go(i + 1));
    window.addEventListener('resize', () => { layout(); go(i); });
  }

  function bootInteractive() {
    $$('[data-split]').forEach(bindSplit);
    $$('[data-core]').forEach(bindCore);
  }
  bootInteractive();
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-split],[data-core]').forEach((el) => { delete el.dataset.bound; });
    bootInteractive();
    e.target.querySelectorAll('[data-predictive-search]').forEach(bindSearch);
  });
})();
